import { API_URL } from "../Config/constant";
import Axios from "axios";

export const GetProducts = async (catagory) => {
  if (catagory) {
    const products = await Axios.get(
      `${API_URL}/products/get-products/${catagory}`
    );
    return products.data.products;
  }
};

export const getAProduct = async (id) => {
  if (id) {
    const product = await Axios.get(`${API_URL}/products/get-product/${id}`);
    return product.data.product;
  }
};
